<template>
    <section aria-hidden="false" aria-labelledby="steps-uid-6-h-0" class="body current" id="steps-uid-6-p-0"
             role="tabpanel" style="max-height: 500px; overflow-y: auto;">
        <div class="row p-b-100">
            <div class="col-md-12">
                <form @submit.prevent="validate">
                    <div class="form-group row" v-if="rows.length === 0">
                        <label class="col-md-2 control-label col-form-label">Commodity</label>
                        <div class="col-md-4 mt-2">
                            <a class="" data-target="#searchAndSelectCommodityModal" data-toggle="modal"
                               href="javascript:void(0)"><b>Click here to
                                add commodity</b></a>
                        </div>
                    </div>
                    <div class="form-group row" v-for="(row, index) in rows">
                        <!-- Good/Service -->
                        <div class="col-sm-3">
                            <p class="form-control" style="height: 42px;">{{row.good.name}} <span
                                    v-if="row.good.code">({{row.good.code}})</span> -
                                {{row.good.variety}}</p>
                        </div>
                        <!-- Quantity -->
                        <div class="col-sm-2 p-l-0 p-r-0">
                            <div class="input-group">
                                <input :class="{'is-invalid': submitted && errors.has('quantity'+index)}"
                                       :id="'quantity'+index"
                                       :name="'quantity'+index"
                                       class="form-control"
                                       data-vv-as="quantity"
                                       placeholder="Quantity"
                                       style="height: 42px; width: calc(100% - 70px)"
                                       type="number"
                                       v-model="row.quantity"
                                       v-validate="'required'">
                                <input :class="{'is-invalid': submitted && errors.has('quantity'+index)}"
                                       style="height: 42px"
                                       :value="row.unit.symbol" class="form-control"
                                       disabled>
                            </div>
                            <div class="invalid-feedback" style="display: block"
                                 v-if="submitted && errors.has('quantity'+index)">{{ errors.first('quantity'+index) }}
                            </div>
                        </div>
                        <!-- Rate -->
                        <div class="col-sm-2 p-r-0">
                            <div class="input-group">
                                <input :class="{'is-invalid': submitted && errors.has('rate'+index)}"
                                       :value="currency" class="form-control"
                                       style="height: 42px"
                                       disabled>
                                <input :class="{'is-invalid': submitted && errors.has('rate'+index)}" :id="'rate'+index"
                                       :name="'rate'+index"
                                       class="form-control"
                                       data-vv-as="rate"
                                       min="1"
                                       placeholder="Rate"
                                       step="any"
                                       style="height: 42px; width: calc(100% - 50px)"
                                       type="number"
                                       v-model="row.rate"
                                       v-validate="'required'">
                            </div>
                            <div class="invalid-feedback" style="display: block"
                                 v-if="submitted && errors.has('rate'+index)">{{ errors.first('rate'+index) }}
                            </div>
                        </div>

                        <div class="col-sm-3 p-r-0">
                            <div class="input-group">
                                <input :id="'provenance'+index"
                                       :name="'provenance'+index"
                                       class="form-control"
                                       data-vv-as="provenance"
                                       placeholder="Provenance"
                                       style="height: 42px; width: calc(100% - 70px)"
                                       type="text"
                                       v-model="row.provenance">
                            </div>
                        </div>

                        <div class="col-sm-2">
                            <div class="form-group button-group">
                                <button data-target="#searchAndSelectCommodityModal"
                                        data-toggle="modal" class="btn btn-outline-success" style="height: 40px;"
                                        type="button" v-if="rows.length === 1 || index === rows.length-1">
                                    <i class="fa fa-cart-plus"/>
                                </button>
                                <button @click="removeRow(index)" class="btn btn-outline-danger" style="height: 40px;"
                                        type="button"><i
                                        class="fa fa-trash-alt"/>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <search-select-commodity :checked-commodity-ids="commodityIds"
                                     @commodity-select="setCommodity"></search-select-commodity>
        </div>
    </section>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import UnitSelect from "../../../common/UnitSelect";
    import {mapGetters} from "vuex";
    import SearchSelectCommodity from "../../../common/SearchSelectCommodity";

    export default {
        name: "Contract",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {SearchSelectCommodity, Multiselect, UnitSelect},
        data() {
            return {
                submitted: false,
                contract: this.$parent.contract,
                marketplaceid: null,
                isLoading: false,
                services: [],
                unit_symbol: '',
                currency: null,
                rows: [
                    // {
                    //     good: null,
                    //     quantity: null,
                    //     rate: null,
                    //     provenance: null,
                    //     unit: {}
                    // }
                ],
                commodity_props: [
                    {
                        key: null,
                        value: null
                    }
                ],
                provenance: null,
                commodityIds: []
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.init();
            });
        },
        methods: {
            async init() {
                this.currency = this.currentOrg.currency_symbol;
                this.contract.currency_id = this.currentOrg.currency_id;
                if (this.contract.items.length > 0) {
                    this.rows = this.contract.items;
                    this.commodityIds = this.rows.map(row=> row.good.id);
                }
                this.marketplaceid = this.currentOrg.marketplace_id;
            },
            async validate() {
                this.contract.items = this.rows;
                this.submitted = true;
                let valid = await this.$validator.validate();
                return valid;
            },
            async getGoodsServices(searchText) {
                this.isLoading = true;
                let reply = await this.$http.get("/marketplaces/" + this.marketplaceid + "/commodities/search", {
                    params: {
                        search: searchText,
                        excludeOld: true
                    }
                });
                this.services = reply.data;
                this.isLoading = false;
            },
            onSelect() {
                this.$refs.reference.unit = {
                    "id": this.contract.goodsSerivces.unit.id,
                    "name": this.contract.goodsSerivces.unit.name,
                    "symbol": this.contract.goodsSerivces.unit.symbol,
                };
                this.contract.unit = this.$refs.reference.unit;
                this.unit_symbol = this.contract.goodsSerivces.unit.symbol;
                this.contract.pricingTerm.rate = this.contract.goodsSerivces.rate.amount;
            },
            setUnit(row) {
                if (row) {
                    row.unit = row.good.unit;
                    row.rate = row.good.rate.amount;
                }
            },

            addRow() {
                this.rows.push({
                    good: null,
                    quantity: null,
                    unit: {}
                });
            },
            removeRow(index) {
                this.rows.splice(index, 1);
                this.commodityIds = this.rows.map(row => row.good.commodity_id);
                this.submitted = false;
            },
            setCommodity(e) {
                let commodities = e;
                commodities.forEach(c=> {
                    let found = this.rows.find(row=> row.good.commodity_id === c.id);
                    if(!found){
                        this.rows.push({
                            good: {
                                commodity_id: c.id,
                                commodity_name: c.name,
                                unit_id: c.unit ? c.unit.id : null,
                                unit_name: c.unit ? c.unit.name : null,
                                unit_symbol: c.unit ? c.unit.symbol : null,
                                ...c
                            },
                            rate: c.rate.amount,
                            quantity: null,
                            provenance: null,
                            unit: {
                                id: c.unit ? c.unit.id : null,
                                name:  c.unit ? c.unit.name : null,
                                symbol: c.unit ? c.unit.symbol : null,
                            }
                        })
                    }
                })
                this.commodityIds = commodities.map(c=> c.id);

            }
        }
    }
</script>

<style scoped>
    .p-b-100 {
        padding-bottom: 100px !important;
    }
</style>
